export default __webpack_public_path__ + "static/media/marauders-map-v5.0-01-00.bca14e01.jpg";